module.exports = __webpack_public_path__ + "static/media/goal02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Tekentool/assets/goals/goal02.svg
// module id = 62
// module chunks = 0